// cache-bust 2026-07-14 — a rollback left several Cloudflare PoPs holding an
// HTML fallback cached under the old bundle's immutable /assets/ URL, which
// bricked the app for anyone routed through them. Rebuilt so the entry chunk
// gets a fresh hash that has never been cached. See functions/assets/[[path]].ts.
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { App } from './app/App';
import { queryClient } from './lib/queryClient';
import { ThemeProvider } from './app/ThemeProvider';
import './styles/tailwind.css';

// Build stamp. Survives minification (a comment does not), so it doubles as a
// way to force a fresh content hash when an /assets/ URL has to be retired,
// and lets anyone confirm which build a browser is actually running:
//   >  window.__WW_BUILD__
(window as unknown as { __WW_BUILD__: string }).__WW_BUILD__ = '2026-07-14T09:40Z';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('#root element not found — check index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
